import { sha256 } from 'js-sha256';

/**
 * Generates SHA256 HMAC of the message using the secret
 * @param {string} message - message to be hashed
 * @param {string} secret - secret to hash the message
 * @returns - the hashed message
 */

export default (message: string, secret: string) => {
  return sha256.hmac(secret, message);
};
